import { jsx } from "react/jsx-runtime";
import { useContext, useEffect, useState } from "react";
import { Calendar } from "@pcln/date-picker";
import { Box } from "pcln-design-system";
import { submitChatMessages } from "../../submitChatMessages.js";
import { ChatbotDataContext } from "../../context/ChatbotDataContext.js";
import analytics from "../../analytics/analytics.js";
import { format } from "date-fns/format";
import { parse } from "date-fns/parse";
import { differenceInCalendarDays } from "date-fns/differenceInCalendarDays";
import { useChatMessagesContext } from "../../hooks/useChatMessagesContext.js";
import { useLoadingStateContext } from "../../hooks/useLoadingStateContext.js";
import { useChatUIContext } from "../../hooks/useChatUIContext.js";
const CalendarComponent = ({ markerComponentProps, isLastMessage })=>{
    const [resolvedStartDate, setResolvedStartDate] = useState('');
    const [resolvedEndDate, setResolvedEndDate] = useState('');
    const [numberOfNights, setNumberOfNights] = useState(0);
    const { submitChatMessagesPayload, handleMarkerResponse, fetchRequestOptions, markerComponents, setErrorMessage, setStreamingText, setIsDisablingInputValue, isMobile } = useContext(ChatbotDataContext);
    const { setLoadingStatus, setLoadingStatusMessage } = useLoadingStateContext();
    const { setOpenErrorComponent } = useChatUIContext();
    const { chatMessages, setChatMessages } = useChatMessagesContext();
    const submitChatMessagesOptions = {
        setChatMessages,
        setStreamingText,
        setLoadingStatus,
        setLoadingStatusMessage,
        setErrorMessage,
        setIsDisablingInputValue,
        requestOptions: fetchRequestOptions,
        markerComponents,
        handleMarkerResponse
    };
    useEffect(()=>{
        if (resolvedStartDate && resolvedEndDate) {
            let nightsText = '';
            if (numberOfNights && numberOfNights > 1) nightsText = ` (${numberOfNights} nights)`;
            else if (numberOfNights && 1 === numberOfNights) nightsText = ` (${numberOfNights} night)`;
            const chatContent = `Search for hotels with Check-in date - ${resolvedStartDate} and check-out date - ${resolvedEndDate}${nightsText}.`;
            const chatMessage = {
                content: chatContent,
                date: new Date(),
                role: 'user'
            };
            const promptMessage = {
                content: chatContent,
                role: 'user'
            };
            chatMessages.pop();
            const updatedChatMessages = [
                ...chatMessages,
                chatMessage
            ];
            setChatMessages(updatedChatMessages);
            submitChatMessages({
                submitChatMessagesPayload: {
                    ...submitChatMessagesPayload,
                    prompts: [
                        promptMessage
                    ]
                },
                setOpenErrorComponent,
                chatMessages: updatedChatMessages,
                ...submitChatMessagesOptions
            }).catch((e)=>{
                analytics.log({
                    message: e?.message,
                    source: 'CalendarComponent'
                });
            });
        }
    }, [
        resolvedEndDate,
        resolvedStartDate
    ]);
    const calculateNights = (startDate, endDate)=>{
        if (startDate && endDate) {
            const start = new Date(parseInt(startDate.substring(0, 4), 10), parseInt(startDate.substring(4, 6), 10) - 1, parseInt(startDate.substring(6, 8), 10));
            const end = new Date(parseInt(endDate.substring(0, 4), 10), parseInt(endDate.substring(4, 6), 10) - 1, parseInt(endDate.substring(6, 8), 10));
            return differenceInCalendarDays(end, start);
        }
        return 0;
    };
    function handleSelectedDates(e, f) {
        if (e && f) {
            if (f?.startDate && f?.endDate) {
                setNumberOfNights(calculateNights(f.startDate, f.endDate));
                const parsedStartDate = parse(f.startDate, 'yyyyMMdd', new Date());
                const parsedEndDate = parse(f.endDate, 'yyyyMMdd', new Date());
                setResolvedStartDate(format(parsedStartDate, 'EEEE, MMMM dd, yyyy'));
                setResolvedEndDate(format(parsedEndDate, 'EEEE, MMMM dd, yyyy'));
            }
        }
    }
    function handleCalenderRef(ref) {
        ref.style.position = 'relative';
        ref.style.marginLeft = '30px';
        ref.scrollIntoView?.({
            behavior: 'smooth'
        });
    }
    if (!isLastMessage) return null;
    return /*#__PURE__*/ jsx(Box, {
        mb: 2,
        maxHeight: isMobile ? '300px' : null,
        overflowY: 'auto',
        children: /*#__PURE__*/ jsx(Calendar, {
            monthsToShow: 1,
            isMobile: isMobile,
            monthWidthPx: 300,
            onChange: handleSelectedDates,
            setCalendarRef: handleCalenderRef,
            calendarWrapperStyles: {
                boxShadow: 'lg'
            }
        })
    });
};
const CalendarComponent_CalendarComponent = CalendarComponent;
export { CalendarComponent_CalendarComponent as default };
